import AllCheckBox from "@/components/Explore/Pubmed/Content/AllCheckBox";
import CartButton from "@/components/Explore/Pubmed/Content/CartButton";
import HelperButton from "@/components/Explore/Pubmed/Content/HelperButton";
import TranslateAllButton from "@/components/Explore/Pubmed/Content/TranslateAllButton";
import { contentListIdsState } from "@/stores/cart";
import React from "react";
import { useRecoilState } from "recoil";
import DeleteButton from "../DeleteButton";
import CommentButton from "./CommentButton";
import styles from "./styles.module.less";

interface IProps {
  pmids: string[];
  collectionId: string;
  refetch: () => Promise<void>;
  verbose: boolean;
}

const ContentHeader: React.FC<IProps> = ({ pmids, collectionId, refetch }) => {
  const [ids, setIds] = useRecoilState(contentListIdsState);

  return (
    <div className={styles.header}>
      <HelperButton />
      <TranslateAllButton ids={pmids} />
      <CommentButton />
      <AllCheckBox pmids={pmids} ids={ids} setIds={setIds} verbose />
      <DeleteButton collectionId={collectionId} refetch={refetch} verbose />
      <CartButton verbose />
    </div>
  );
};

export default ContentHeader;
